import { useState } from 'react';
import { useAccount, useReadContract } from 'wagmi';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { VERIFY_NFT_URL } from '../api';
import CryptoJS from 'crypto-js';

// Create axios instance with consistent configuration
const nftAxios = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

// ERC-721 balanceOf ABI
const erc721ABI = [
  {
    inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
];

// Original NFT Contract
const NFT_CONTRACT_ADDRESS = '0xa980f072bc06d67faec2b03a8ada0d6c9d0da9f8';
const NFT_NAME = 'Legacy Eggs';

// Encryption and decryption functions
const SECRET = "mySecretKey123x";
const IV_LENGTH = 32; // 16 bytes for AES

const encryptMessage = (message) => {
  const encrypted = CryptoJS.AES.encrypt(message, SECRET);
  return encrypted.toString();
};

export const useNftVerification = () => {
  const { address } = useAccount();
  const { isAuthenticated } = useAuth();
  const [isVerifying, setIsVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);

  // Check NFT balance using wagmi's useReadContract
  const { data: nftBalance, isLoading: isBalanceLoading } = useReadContract({
    abi: erc721ABI,
    address: NFT_CONTRACT_ADDRESS,
    functionName: 'balanceOf',
    args: [address || '0x0000000000000000000000000000000000000000'],
  });

  // The main function to verify NFT ownership
  const verifyNft = async () => {
    if (!address) {
      setError('Wallet not connected');
      return false;
    }

    if (!isAuthenticated) {
      setError('You must be logged in with Discord first');
      return false;
    }

    setIsVerifying(true);
    setError(null);

    // Check if user has the NFT
    if (!nftBalance || Number(nftBalance.toString()) === 0) {
      setError(`You don't own any ${NFT_NAME}`);
      setIsVerifying(false);
      return false;
    }

    try {
      // Verify with the server
      console.log('Verifying NFT with server...');
      console.log('NFT balance:', nftBalance);
      console.log('Encrypted NFT balance:', encryptMessage(nftBalance.toString()));
      const response = await nftAxios.post(
        VERIFY_NFT_URL,
        {
          walletAddress: address,
          contractAddress: NFT_CONTRACT_ADDRESS,
          nftBalance: encryptMessage(nftBalance.toString()),
        }
      );

      console.log('NFT verification response:', response.data);

      if (response.data.verified) {
        setIsVerified(true);
        setIsVerifying(false);
        return true;
      } else {
        setError(response.data.message || 'NFT verification failed');
        setIsVerifying(false);
        return false;
      }
    } catch (err) {
      console.error('Error verifying NFT:', err);
      setError(err.response?.data?.message || 'Error verifying NFT ownership');
      setIsVerifying(false);
      return false;
    }
  };

  return {
    verifyNft,
    isVerifying,
    isVerified,
    error,
    hasNft: nftBalance && Number(nftBalance) > 0,
  };
}; 